import { School, MapPin, Map, Star, FileCheck, Briefcase, MessageCircleQuestion } from 'lucide-react';

export default function AdminIndex() {
  const adminSections = [
    { name: 'Schools', icon: <School className="h-8 w-8" />, description: 'Manage school profiles and information', count: '14,687' },
    { name: 'Cities', icon: <MapPin className="h-8 w-8" />, description: 'Manage cities and locations', count: '50+' },
    { name: 'Areas', icon: <Map className="h-8 w-8" />, description: 'Manage areas and localities', count: '500+' },
    { name: 'Reviews', icon: <Star className="h-8 w-8" />, description: 'Manage school reviews and ratings', count: '25K+' },
    { name: 'Claims', icon: <FileCheck className="h-8 w-8" />, description: 'Manage school claim requests', count: '150+' },
    { name: 'Jobs', icon: <Briefcase className="h-8 w-8" />, description: 'Manage job postings and applications', count: '1K+' },
    { name: 'Q & A', icon: <MessageCircleQuestion className="h-8 w-8" />, description: 'Manage questions and answers', count: '5K+' }
  ];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Admin Dashboard</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">Manage platform data and configurations</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {adminSections.map((section) => (
          <div
            key={section.name}
            className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="text-brandColor">{section.icon}</div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{section.name}</h3>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400">{section.description}</p>
              </div>
              <span className="text-2xl font-bold text-brandColor">{section.count}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
